import { Filter } from 'model/Filters';

const translateAggregationsPaths: Record<string, string> = {
  'activityType.activity': 'experienceTypes',
  'subcategory.items[]': 'subcategories',
  'duration.items[]': 'durationRanges',
  'languages.items[]': 'languages',
  'price.items[]': 'priceRanges',
  'tags.items[]': 'tagsBySubCategory',
  'family-friendly': 'is_family_friendly',
  'other.transport_mode.items[]': 'transport_mode',
};

export const activitiesKeys: string[] = [
  'sports-leisure',
  'cooking-classes',
  'workshops',
  'home-dinners',
  'tastings',
  'wildlife-nature',
];

export function areThereResults(
  aggregations: any,
  category: string,
  key: string | null = null,
  showUnknownCategoriesAsAvailable = false,
  subcategory: string | null = null,
): boolean {
  if (!aggregations) {
    // we do not have searchResults yet, don't render links
    return false;
  }
  if (!translateAggregationsPaths[category]) {
    // this category is not in aggregations, don't render links
    return showUnknownCategoriesAsAvailable;
  }
  if (
    !aggregations[translateAggregationsPaths[category]] ||
    !aggregations[translateAggregationsPaths[category]].buckets
  ) {
    // aggregations from server doesn't include this category
    return false;
  }
  const aggregationPath = translateAggregationsPaths[category];
  const highestLevelItems = aggregations[aggregationPath].buckets;
  let overallCount = 0;
  for (const item of highestLevelItems as any[]) {
    if (aggregationPath.startsWith('is_') && item.key === 'T') {
      return item.doc_count > 0;
    }
    if (item.key && item.key === key) {
      return item.doc_count > 0;
    }
    if (item.tags?.buckets) {
      if (
        !subcategory ||
        item.key === subcategory ||
        (subcategory === 'activities' && activitiesKeys.includes(item.key))
      ) {
        for (const tag of item.tags.buckets as any[]) {
          if (tag.key && tag.key === key) {
            return tag.doc_count > 0;
          }
        }
      }
    }
    overallCount += item.doc_count;
  }
  if (!key) {
    return overallCount > 0;
  }
  return false;
}

export function shouldThisTagBeShown(
  aggregations: any,
  selectedSubcategories: Filter | null | undefined,
  uid: string,
  value: string,
  subcategory: string | null | undefined,
): boolean {
  return (
    areThereResults(aggregations, uid, value, false, subcategory) ||
    (selectedSubcategories?.subOptions?.some((s) => s.value === value) ?? false)
  );
}

export function getSubcategoryFromFilters(
  selectedCategories: Filter[] = [],
): string | null {
  const subcategories = selectedCategories.filter(
    (f) => f.uid === 'subcategory.items[]',
  );
  return subcategories?.[0]?.subOptions?.[0]?.value ?? null;
}
